export default __webpack_public_path__ + "static/media/clock.06b02662.png";